import { Component, Input, NgZone, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ImageDisplayComponent } from '../../../../modals/image-display/image-display.component';

@Component({
  selector: 'app-table-element',
  templateUrl: './table-element.component.html',
  styleUrls: ['./table-element.component.scss']
})
export class TableElementComponent implements OnInit {

  @Input('content') data: any;
  imgArray: any = [];
  validImg: boolean = false;
  constructor(public dialog: MatDialog, public _ngZone: NgZone) { }

  ngOnInit(): void {


    console.log(typeof this.data)
    if (typeof this.data == 'object') {
      console.log(this.data, this.data.seconds, this.data.nanoseconds)
      if (this.data.seconds && (this.data.nanoseconds || this.data.nanoseconds == 0)) {
        this.data = new Date(this.data.seconds * 1000 + this.data.nanoseconds / 1000000).toLocaleDateString();
      }

    }
  }

  checkIfUrl(data): boolean {
    //  console.log(element, column)


    this.validImg = this.validURL(data)
    if (this.validImg)
      this.imgArray.push({ src: data, thumb: data, caption: 'signature' })



    return this.validImg

  }

  openImage(url) {


    this._ngZone.run(() => {
      this.dialog.open(ImageDisplayComponent, {
        width: '50vw',
        height: '50vh',
        data: {
          mediaSource: url
        }
      })
    })

  }

  validURL(str) {


    try {
      let url = new URL(str)
      return /\.(jpg|jpeg|png|webp|avif|gif)$/.test(url.href.split('?')[0])
    }
    catch (err) {
      return /\.(jpg|jpeg|png|webp|avif|gif)$/.test(str)
    }
   /* var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    return !!pattern.test(str);*/
  }

}
